// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__wUfn-","inner":"styles_inner__M0evJ","text":"styles_text__1p1gi"};